import react from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import ModalResumenEvolucion from "./ModalResumenEvolucion";
import SignatureCanvas from 'react-signature-canvas';
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import { generarPdfConTextoNativo } from '../../../utils/pdfHelpers';
import { debeFiltrarPorProfesional, getUserData } from '../../../utils/userAccessHelpers';
import RegistroRipsSinFev from "../rips/RegistroRipsSinFev";
import RegistroRipsFev from "../rips/RegistroRipsFev";
import RegistroRipsConvenio from "../rips/RegistroRipsConvenio";
import ModalExamenes from "./ModalExamenes";
import ModalFormulas from "./ModalFormulas";
import ModalIncapacidades from "./ModalIncapacidades";
import ModalRecomendaciones from "./ModalRecomendaciones";
import ModalRemisiones from "./ModalRemisiones";
import ModalContraremisiones from "./ModalContraremisiones";
import ModalConsentimientos from "./ModalConsentimientos";
import ModalOdontograma from "./ModalOdontograma";
import ModalArchivosClinicos from "./ModalArchivosClinicos";
import DocumentoPacienteModal from "./DocumentoPacienteModal";

function ModalEvolucion(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loadingPaciente, setLoadingPaciente] = useState(true); // 🆕 Loading específico para datos del paciente
    const [errorPaciente, setErrorPaciente] = useState(null); // 🆕 Error al cargar paciente
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState({});
    const [hasPermission, setHasPermission] = useState(null); // 🔒 Control de acceso por permiso

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));
    const [paciente, setPaciente] = useState(null); // 🆕 Estado para datos del paciente cargados desde backend

    const [procedimiento, setProcedimiento] = useState('');
    const [proximaCita, setProximaCita] = useState('');
    const [eventosAdversos, setEventosAdversos] = useState('');
    const [planManejoEventoAdverso, setPlanManejoEventoAdverso] = useState('');
    const [horaInicial, setHoraInicial] = useState('');
    const [plantillasEventosAdversos, setPlantillasEventosAdversos] = useState([]);
    const panelPlanManejo = useRef(0);


    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)

    const [historialEvoluciones, setHistorialEvoluciones] = useState([]);


    const [tituloResumen, setTituloResumen] = useState();
    const [resumenEvolucionIndividual, setResumenEvolucionIndividual] = useState();
    const [profesionalEvolucionIndividual, setProfesionalEvolucionIndividual] = useState();
    const [registroMedicoEvolucionIndividual, setRegistroMedicoEvolucionIndividual] = useState();
    const [codigoHabilitacionEvolucionIndividual, setCodigoHabilitacionEvolucionIndividual] = useState();
    const [firmaEvolucionIndividual, setFirmaEvolucionIndividual] = useState();
    const logoImg = '/smile/dist/img/logo-2.png';

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();
    let userdata = [];

    const canvasRef = useRef(0);

    const [firmaPaciente, setFirmaPaciente] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [listaPlantillas, setListaPlantillas] = useState([]);
    const [plantillaSeleccionadaId, setPlantillaSeleccionadaId] = useState('');
    const [contenidoPlantillaSeleccionada, setContenidoPlantillaSeleccionada] = useState('');
    const [contenidoPlantillaCopiado, setContenidoPlantillaCopiado] = useState(false);

    const [parametrosEvolucion, setParametrosEvolucion] = useState([]);
    const [contenidoPersonalizado, setContenidoPersonalizado] = useState('');
    const [habilitarBotonGuardar, setHabilitarBotonGuardar] = useState(false);

    const [showTratamientos, setShowtratamientos] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [evolucionSeleccionada, setEvolucionSeleccionada] = useState(null);
    const [modoVisualizacion, setModoVisualizacion] = useState(false);
    const [contenidoVistaPreviaRegistro, setContenidoVistaPreviaRegistro] = useState('');
    const [showModalRips, setShowModalRips] = useState(false); // 🆕 Modal de confirmación RIPS
    const [esFacturador, setEsFacturador] = useState(false); // 🆕 Estado para saber si el usuario es facturador
    const [showRipsFev, setShowRipsFev] = useState(false);
    const [showRipsSinFev, setShowRipsSinFev] = useState(false);
    const [showRipsConvenio, setShowRipsConvenio] = useState(false);
    const [showExamenes, setShowExamenes] = useState(false);
    const [showFormulas, setShowFormulas] = useState(false);
    const [showIncapacidades, setShowIncapacidades] = useState(false);
    const [showRecomendaciones, setShowRecomendaciones] = useState(false);
    const [showRemisiones, setShowRemisiones] = useState(false);
    const [showContraremisiones, setShowContraremisiones] = useState(false);
    const [showConsentimientos, setShowConsentimientos] = useState(false);
    const [showOdontograma, setShowOdontograma] = useState(false);
    const [showArchivosClinicos, setShowArchivosClinicos] = useState(false);
    const [cargarHistorialExamenes, setCargarHistorialExamenes] = useState(false);
    const [cargarHistorialFormulas, setCargarHistorialFormulas] = useState(false);
    const [cargarHistorialIncapacidades, setCargarHistorialIncapacidades] = useState(false);
    const [cargarHistorialRecomendaciones, setCargarHistorialRecomendaciones] = useState(false);
    const [cargarHistorialRemisiones, setCargarHistorialRemisiones] = useState(false);
    const [cargarHistorialContraremisiones, setCargarHistorialContraremisiones] = useState(false);
    const [cargarHistorialConsentimientos, setCargarHistorialConsentimientos] = useState(false);
    const [cargarHistorialRipsConvenio, setCargarHistorialRipsConvenio] = useState(false);
    const [tienePermisoDocumentos, setTienePermisoDocumentos] = useState(false);
    const [tienePermisoRips, setTienePermisoRips] = useState(false);
    const [tienePermisoToxina, setTienePermisoToxina] = useState(false);
    const [tienePermisoOdontograma, setTienePermisoOdontograma] = useState(false);
    const [tienePermisoHistoriaClinica, setTienePermisoHistoriaClinica] = useState(false);
    const [tienePermisoEvolucionMenu, setTienePermisoEvolucionMenu] = useState(false);

    // 🎯 ESTADOS PARA ACORDEONES REACT - Todos abiertos por defecto para aprovechar espacio
    const [acordeonProcedimiento, setAcordeonProcedimiento] = useState(true);
    const [acordeonPersonalizado, setAcordeonPersonalizado] = useState(true);
    const [acordeonProximaCita, setAcordeonProximaCita] = useState(true);
    const [acordeonEventos, setAcordeonEventos] = useState(true);
    const [acordeonPlanManejo, setAcordeonPlanManejo] = useState(true);
    const [acordeonFirmaPaciente, setAcordeonFirmaPaciente] = useState(true);

    const ordenarParametrosPorId = (lista = []) => {
        return [...lista].sort((a, b) => {
            const idA = parseInt(a?.id, 10) || 0;
            const idB = parseInt(b?.id, 10) || 0;
            return idA - idB;
        });
    };

    useEffect(() => {

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a evolución
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            
            let tienePermiso = false;
            if (userdata.permissions && Array.isArray(userdata.permissions)) {
                tienePermiso = userdata.permissions.some(p => p.slug === 'evolucionPaciente');
            } else if (userdata.up && userdata.up.includes('evolucionPaciente')) {
                tienePermiso = true;
            }
            
            setHasPermission(tienePermiso);

            const verificarPermisoSlug = (slug) => {
                if (userdata.permissions && Array.isArray(userdata.permissions)) {
                    return userdata.permissions.some(p => p.slug === slug);
                }
                if (userdata.up && Array.isArray(userdata.up)) {
                    return userdata.up.includes(slug);
                }
                return false;
            };
            setTienePermisoDocumentos(verificarPermisoSlug('documentosPaciente'));
            setTienePermisoRips(verificarPermisoSlug('ripsPaciente'));
            setTienePermisoToxina(verificarPermisoSlug('toxinaPaciente'));
            setTienePermisoOdontograma(verificarPermisoSlug('odontogramaPaciente'));
            setTienePermisoHistoriaClinica(verificarPermisoSlug('historiaClinicaPaciente'));
            setTienePermisoEvolucionMenu(verificarPermisoSlug('evolucionPaciente'));
            
            if (!tienePermiso) {
                return; // Detener ejecución si no tiene permisos
            }
        } else {
            setHasPermission(false);
            return;
        }

        // 🆕 Usar prop esFacturador del padre en lugar de leer de localStorage
        if (props.esFacturador !== undefined && props.esFacturador !== null) {
            setEsFacturador(props.esFacturador);
            console.log('Campo facturador recibido del padre:', props.esFacturador, '→ Es facturador:', props.esFacturador);
        } else {
            // Fallback: leer de localStorage si no viene la prop
            if (localStorage.getItem('userdata')) {
                userdata = JSON.parse(localStorage.getItem('userdata'));
                
                if (userdata.facturador !== undefined && userdata.facturador !== null) {
                    const facturadorNum = parseInt(userdata.facturador);
                    setEsFacturador(facturadorNum === 0);
                    console.log('Campo facturador detectado en localStorage:', userdata.facturador, '(tipo:', typeof userdata.facturador, ') → Convertido a:', facturadorNum, '→ Es facturador:', facturadorNum === 0);
                } else {
                    console.log('Campo facturador no definido, usando valor por defecto (NO es facturador)');
                    setEsFacturador(false);
                }
            }
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client')
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('plantillas-eventos-adversos')
            .then(response => {
                if (response.status === 200) {
                    setPlantillasEventosAdversos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando plantillas eventos adversos:', error);
                setPlantillasEventosAdversos([]);
            });

        axios.get('/perfil')
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/otras-plantillas')
            .then(response => {
                if (response.status === 200) {
                    setListaPlantillas(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando otras plantillas:', error);
                setListaPlantillas([]);
            });

        axios.get('/parametros-evolucion')
            .then(response => {
                if (response.status === 200) {
                    setParametrosEvolucion(ordenarParametrosPorId(response.data || []));
                }
            })
            .catch(error => {
                console.log('Error cargando parámetros evolución:', error);
                setParametrosEvolucion(null);
            });

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        // 🆕 TAREA 4.1.1 - Cargar datos del paciente desde backend
        if (paciente_id) {
            setLoadingPaciente(true);
            setErrorPaciente(null);
            
            // Usar endpoint existente /paciente con query params
            const configPaciente = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    id: paciente_id
                }
            };
            
            console.log('🔍 Cargando datos del paciente con ID:', paciente_id);
            
            axios.get('/paciente', configPaciente)
                .then(response => {
                    if (response.status === 200) {
                        console.log('✅ Datos del paciente recibidos del backend:', response.data);
                        
                        // El endpoint /paciente devuelve un array con un objeto
                        const datosPaciente = Array.isArray(response.data) ? response.data[0] : response.data;
                        
                        console.log('📋 Datos del paciente procesados:', {
                            primerNombre: datosPaciente.primer_nombre,
                            segundoNombre: datosPaciente.segundo_nombre,
                            primerApellido: datosPaciente.primer_apellido,
                            segundoApellido: datosPaciente.segundo_apellido,
                            tipoDocumento: datosPaciente.tipo_documento,
                            numeroDocumento: datosPaciente.numero_documento
                        });
                        
                        // Normalizar nombres de campos (snake_case a camelCase)
                        const pacienteNormalizado = {
                            primerNombre: datosPaciente.primer_nombre,
                            segundoNombre: datosPaciente.segundo_nombre,
                            primerApellido: datosPaciente.primer_apellido,
                            segundoApellido: datosPaciente.segundo_apellido,
                            tipoDocumento: datosPaciente.tipo_documento,
                            numeroDocumento: datosPaciente.numero_documento,
                            ...datosPaciente
                        };
                        
                        setPaciente(pacienteNormalizado);
                        console.log('✅ Estado paciente actualizado:', pacienteNormalizado);
                    }
                    setLoadingPaciente(false);
                })
                .catch(error => {
                    console.error('❌ Error cargando datos del paciente:', error);
                    console.error('❌ Detalles del error:', error.response?.data);
                    setErrorPaciente('No se pudieron cargar los datos del paciente');
                    setLoadingPaciente(false);
                });
        } else {
            console.error('❌ No se proporcionó ID de paciente en la URL');
            setErrorPaciente('No se proporcionó ID de paciente en la URL');
            setLoadingPaciente(false);
        }

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    const [vistaPiRevision, setVistaPiRevision] = useState(0);

    useEffect(() => {
        const onVistaPiChanged = () => setVistaPiRevision((v) => v + 1);
        window.addEventListener('smile-vista-pi-changed', onVistaPiChanged);
        return () => window.removeEventListener('smile-vista-pi-changed', onVistaPiChanged);
    }, []);

    useEffect(() => {
        // Esperar a que termine la carga del paciente para que en la vista consolidada
        // no queden "Paciente no identificado / Documento no disponible".
        if (loadingPaciente) return;
        cargaritems();
    }, [props.cargarHistorial, loadingPaciente, paciente?.numeroDocumento, paciente?.primerNombre, paciente?.primerApellido, vistaPiRevision]);

    // 🆕 TAREA 4.1.1 - Helper para obtener datos del paciente (con fallback a props)
    const obtenerDatosPaciente = () => {
        // Priorizar datos cargados desde backend, fallback a props para compatibilidad
        const datosPaciente = paciente || props.paciente;
        
        console.log('🔍 obtenerDatosPaciente - datosPaciente:', datosPaciente);
        
        if (!datosPaciente) {
            console.warn('⚠️ No hay datos del paciente disponibles');
            return {
                nombreCompleto: 'Paciente no identificado',
                documentoCompleto: 'Documento no disponible'
            };
        }

        // Soportar tanto camelCase como snake_case
        const primerNombre = datosPaciente.primerNombre || datosPaciente.primer_nombre || '';
        const segundoNombre = datosPaciente.segundoNombre || datosPaciente.segundo_nombre || '';
        const primerApellido = datosPaciente.primerApellido || datosPaciente.primer_apellido || '';
        const segundoApellido = datosPaciente.segundoApellido || datosPaciente.segundo_apellido || '';
        const tipoDocumento = datosPaciente.tipoDocumento || datosPaciente.tipo_documento || '';
        const numeroDocumento = datosPaciente.numeroDocumento || datosPaciente.numero_documento || '';

        const nombreCompleto = `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim() || 'Paciente no identificado';
        
        // Construir documento completo solo si hay datos válidos
        let documentoCompleto = 'Documento no disponible';
        if (tipoDocumento && numeroDocumento) {
            documentoCompleto = `${tipoDocumento} - ${numeroDocumento}`;
        } else if (numeroDocumento) {
            documentoCompleto = numeroDocumento;
        }

        console.log('✅ obtenerDatosPaciente - resultado:', { nombreCompleto, documentoCompleto });

        return {
            nombreCompleto,
            documentoCompleto,
            ...datosPaciente
        };
    };

    const piePacienteEvolucion = () => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
        return [nombreCompleto, documentoCompleto].filter(Boolean).join('\n');
    };

    /** Misma presentación que consentimientos; solo usar cuando hay trazo (no mostrar bloque vacío). */
    const htmlFirmaPacienteSoloSiHayTrazo = (firmaSrc, pieTextoPlano) => {
        if (!firmaSrc) return '';
        const pieHtml = pieTextoPlano
            ? `<div style="font-size: ${EVOL_DOC_FS}; color: #6c757d; white-space: pre-line;">${escapeHtmlBasico(pieTextoPlano)}</div>`
            : '';
        return `
                        <div style="margin-top: 12px; margin-bottom: 12px; page-break-inside: avoid;">
                            <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase;">Firma del paciente</div>
                            <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                                <div style="flex: 1; min-width: 160px;">${pieHtml}</div>
                                <div style="flex-shrink: 0;">
                                    <img src="${firmaSrc}" alt="" style="max-width: 170px; max-height: 80px; display: block;" />
                                </div>
                            </div>
                        </div>`;
    };

    const escapeHtmlBasico = (s) => String(s ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const EVOL_DOC_FS = '13px';
    const EVOL_DOC_PAD = '12px';
    const EVOL_DOC_COLOR = '#212529';
    const EVOL_DOC_TITLE_COLOR = '#325e68';
    const EVOL_META_LABEL_W = '108px';
    const EVOL_SEP_COLOR = '#e9ecef';
    const EVOL_TEXT_WRAP = 'overflow-wrap: anywhere; word-break: break-word; max-width: 100%;';

    const wrapEvolucionDocumento = (inner) => `
        <div class="evolucion-doc" style="font-size: ${EVOL_DOC_FS}; line-height: 1.45; color: ${EVOL_DOC_COLOR}; padding: 0 ${EVOL_DOC_PAD}; box-sizing: border-box; max-width: 100%; overflow-x: hidden; ${EVOL_TEXT_WRAP}">
            ${inner}
        </div>`;

    const nombreProfesionalEvol = (evol) => {
        const n = evol?.profesional_tratante_completo;
        if (n && n !== 'null' && n !== 'No registrado') return n;
        return 'No registrado';
    };

    const htmlTituloHistorialEvoluciones = () => `
        <div style="font-weight: 700; color: ${EVOL_DOC_TITLE_COLOR}; letter-spacing: 0.04em; margin: 0 0 12px 0; text-transform: uppercase;">
            HISTORIAL DE EVOLUCIONES
        </div>`;

    const htmlFilaMetadataGrid = (etiqueta, valor) => `
        <div style="display: grid; grid-template-columns: ${EVOL_META_LABEL_W} minmax(0, 1fr); column-gap: 10px; align-items: start;">
            <span style="font-weight: 700;">${etiqueta}</span>
            <span style="word-break: break-word;">${valor}</span>
        </div>`;

    const htmlSeparadorEvolucion = () => `
        <div style="height: 1px; background-color: ${EVOL_SEP_COLOR}; margin: 24px 0; width: 100%;" role="presentation" aria-hidden="true"></div>`;

    const htmlMetadataPacienteDocumento = (nombreCompleto, documentoCompleto) => `
        <div style="display: flex; flex-wrap: wrap; gap: 12px 40px; margin-bottom: 8px;">
            <div style="flex: 1 1 280px; min-width: 0; max-width: 100%; display: flex; flex-direction: column; gap: 6px;">
                ${htmlFilaMetadataGrid('Paciente:', escapeHtmlBasico(nombreCompleto))}
            </div>
            <div style="flex: 1 1 280px; min-width: 0; max-width: 100%; display: flex; flex-direction: column; gap: 6px;">
                ${htmlFilaMetadataGrid('Documento:', escapeHtmlBasico(documentoCompleto))}
            </div>
        </div>`;

    const htmlMetadataProfesionalFecha = (profesional, fechaHora, opciones = {}) => {
        const margenTop = opciones.margenTop || '0';
        return `
        <div style="display: flex; flex-wrap: wrap; gap: 12px 40px; margin: ${margenTop} 0 0 0;">
            <div style="flex: 1 1 280px; min-width: 0; max-width: 100%; display: flex; flex-direction: column; gap: 6px;">
                ${htmlFilaMetadataGrid('Profesional:', escapeHtmlBasico(profesional))}
            </div>
            <div style="flex: 1 1 280px; min-width: 0; max-width: 100%; display: flex; flex-direction: column; gap: 6px;">
                ${htmlFilaMetadataGrid('Fecha y hora:', escapeHtmlBasico(fechaHora))}
            </div>
        </div>`;
    };

    /** Paciente, documento, profesional y fecha en cuadrícula simétrica (etiquetas con ancho fijo). */
    const htmlMetadataSuperiorCompleta = (nombreCompleto, documentoCompleto, profesional, fechaHora, opciones = {}) => {
        const margenTop = opciones.margenTop || '0';
        const margenBottom = opciones.margenBottom || '0';
        return `
        <div style="display: flex; flex-wrap: wrap; gap: 12px 40px; margin: ${margenTop} 0 ${margenBottom} 0; max-width: 100%; ${EVOL_TEXT_WRAP}">
            <div style="flex: 1 1 280px; min-width: 0; max-width: 100%; display: flex; flex-direction: column; gap: 6px;">
                ${htmlFilaMetadataGrid('Paciente:', escapeHtmlBasico(nombreCompleto))}
                ${htmlFilaMetadataGrid('Profesional:', escapeHtmlBasico(profesional))}
            </div>
            <div style="flex: 1 1 280px; min-width: 0; max-width: 100%; display: flex; flex-direction: column; gap: 6px;">
                ${htmlFilaMetadataGrid('Documento:', escapeHtmlBasico(documentoCompleto))}
                ${htmlFilaMetadataGrid('Fecha y hora:', escapeHtmlBasico(fechaHora))}
            </div>
        </div>`;
    };

    /** Firma del profesional parametrizada en perfil (/perfil → firma_blob); resumen completo con profesional independiente. */
    const htmlFirmaProfesionalParametrizada = (firmaSrc, nombre, rm, textoPiePerfil = '') => {
        if (!firmaSrc) return '';
        const pie = (textoPiePerfil && String(textoPiePerfil).trim()) || '';
        const nombreEsc = nombre || '';
        const rmEsc = rm || 'N/A';
        const bloquePie = pie
            ? `<div style="font-size: ${EVOL_DOC_FS}; color: #6c757d; line-height: 1.45; white-space: pre-line;">${escapeHtmlBasico(pie)}</div>`
            : `<div style="font-size: ${EVOL_DOC_FS}; color: #6c757d; line-height: 1.45;">
                    <strong>${escapeHtmlBasico(nombreEsc)}</strong><br/>RM: ${escapeHtmlBasico(rmEsc)}
                </div>`;
        return `
                            ${htmlSeparadorEvolucion()}
                            <div style="margin-top: 0; margin-bottom: 12px; page-break-inside: avoid;">
                                <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase;">Firma del profesional</div>
                                <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                                    <div style="flex: 1; min-width: 160px;">${bloquePie}</div>
                                    <div style="flex-shrink: 0;">
                                        <img src="${firmaSrc}" alt="" style="max-width: 180px; max-height: 90px; display: block;" />
                                    </div>
                                </div>
                            </div>`;
    };

    /** Firma del profesional autor de la evolución: perfil (users.firma_blob vía API) o legado en evol.firma. */
    const firmaProfesionalImagenEvolucion = (evol) => {
        if (!evol) return '';
        if (evol.profesional_firma_blob) return evol.profesional_firma_blob;
        return evol.firma || '';
    };

    const pieFirmaProfesionalDesdeEvol = (evol) => {
        if (!evol || evol.texto_pie_firma_usuario == null || evol.texto_pie_firma_usuario === '') return '';
        return String(evol.texto_pie_firma_usuario).trim();
    };

    const htmlFirmaProfesionalDesdeEvol = (evol) => {
        if (!evol) return '';
        const tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
            evol.profesional_tratante_completo !== 'null' &&
            evol.profesional_tratante_completo !== 'No registrado');
        const imgFirma = firmaProfesionalImagenEvolucion(evol);
        const mostrarFirmaProfesional = tieneProfesionalRegistrado && imgFirma;
        if (!mostrarFirmaProfesional) return '';
        const pie = pieFirmaProfesionalDesdeEvol(evol);
        const bloquePie = pie
            ? `<div style="font-size: ${EVOL_DOC_FS}; color: #6c757d; line-height: 1.45; white-space: pre-line;">${escapeHtmlBasico(pie)}</div>`
            : `<div style="font-size: ${EVOL_DOC_FS}; color: #6c757d; line-height: 1.45;">
                    <strong>${escapeHtmlBasico(evol.profesional || '')}</strong><br/>RM: ${escapeHtmlBasico(evol.registro_medico || 'N/A')}
                </div>`;
        return `
                            ${htmlSeparadorEvolucion()}
                            <div style="margin-top: 0; margin-bottom: 12px; page-break-inside: avoid;">
                                <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase;">Firma del profesional</div>
                                <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                                    <div style="flex: 1; min-width: 160px;">${bloquePie}</div>
                                    <div style="flex-shrink: 0;">
                                        <img src="${imgFirma}" alt="" style="max-width: 180px; max-height: 90px; display: block;" />
                                    </div>
                                </div>
                            </div>`;
    };

    const metadataFirmaProfesionalEvol = (evol) => {
        const meta = {
            tipo: 'profesional',
            nombre: evol.profesional || '',
            registroMedico: evol.registro_medico || 'N/A',
            codigoHabilitacion: evol.codigo_habilitacion || 'N/A'
        };
        const pie = pieFirmaProfesionalDesdeEvol(evol);
        if (pie) meta.textoPieFirma = pie;
        return meta;
    };

    const esUsuarioProfesionalIndependiente = () => debeFiltrarPorProfesional(getUserData());

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/evoluciones', config2)
            .then(response => {

                setHistorialEvoluciones(response.data);

                let cuerpoConsolidado = '';
                if (response.data && response.data.length > 0) {
                    const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
                    cuerpoConsolidado += htmlTituloHistorialEvoluciones();
                }

                response.data.forEach((evol, index) => {
                    const separadorEntreEvoluciones = index > 0
                        ? '<div style="margin: 20px 0; border-top: 1px dashed #ced4da;"></div>'
                        : '';

                    const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();

                    cuerpoConsolidado += separadorEntreEvoluciones;
                    cuerpoConsolidado += htmlMetadataSuperiorCompleta(
                        nombreCompleto,
                        documentoCompleto,
                        nombreProfesionalEvol(evol),
                        obtenerFechaHoraVisualizacion(evol),
                        { margenTop: index > 0 ? '8px' : '0', margenBottom: '0' }
                    );
                    cuerpoConsolidado += htmlSeparadorEvolucion();
                    cuerpoConsolidado += htmlSegmentoContenidoEvolucion(evol);

                    if (!esProfesionalIndependiente) {
                        cuerpoConsolidado += htmlFirmaProfesionalDesdeEvol(evol);
                    }
                    if (evol.firma_paciente) {
                        cuerpoConsolidado += htmlFirmaPacienteSoloSiHayTrazo(evol.firma_paciente, piePacienteEvolucion());
                    }
                });

                if (esProfesionalIndependiente) {
                    cuerpoConsolidado += htmlFirmaProfesionalParametrizada(
                        firmaimg,
                        nombreProfesional,
                        registroMedico,
                        textoPieFirma
                    );
                }

                setConsolidado(cuerpoConsolidado ? wrapEvolucionDocumento(cuerpoConsolidado) : '');
            })
            .catch(error => {
                console.log('Error cargando evoluciones:', error);
                setHistorialEvoluciones([]);
                setConsolidado('');
            })
    }



    const procedimientoHandler = (event, editor) => {
        setProcedimiento(editor.getData());
    }
    const proximaCitaHandler = (event, editor) => {
        setProximaCita(editor.getData());
    }
    const eventosAdversosHandler = (event, editor) => {
        setEventosAdversos(editor.getData());
    }
    const planManejoEventoAdversoHandler = (event, editor) => {
        setPlanManejoEventoAdverso(editor.getData());
    }


    const renderizarContenidoPersonalizado = (contenidoPersonalizado, opciones = {}) => {
        const compacto = opciones.compacto === true;
        const mt = compacto ? '4px' : '8px';
        const fsCampo = EVOL_DOC_FS;
        const fsNombre = EVOL_DOC_FS;

        if (!contenidoPersonalizado) {
            return "";
        }

        let contenido;
        try {
            contenido = JSON.parse(contenidoPersonalizado);
        } catch (e) {
            return "";
        }

        // Viñetas/tabs Unicode → ASCII; saltos de línea → <br> (jsPDF no soporta ●/•)
        const formatearValorTexto = (valor) => {
            if (valor == null) return '';
            let s = String(valor);
            s = s.replace(/[\u2028\u2029]/g, '\n');
            s = s.replace(/[\u2022\u2023\u2043\u25CF\u25CB\u25A0\u25A1\u25AA\u25AB\u25B6\u25B8\u25E6\u2219]/g, '-');
            s = s.replace(/\t+/g, ' ');
            s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            s = s.replace(/\n/g, '<br />');
            return s;
        };

        let resultado = "";

        if (contenido && Array.isArray(contenido)) {
            contenido.forEach((campo) => {
                // 🔧 OCULTAR CAMPOS VACÍOS - Solo mostrar si tiene valor
                if (campo.tipo === 'checkbox') {
                    // Mostrar checkboxes marcados como bloque independiente para evitar pegarse al bloque anterior.
                    if (campo.check) {
                        resultado += `<div style="margin-top: ${mt}; font-size: ${fsCampo}; line-height: 1.35; ${EVOL_TEXT_WRAP}"><strong style="font-size: ${fsNombre}">${campo.nombre}:</strong> Sí</div>`;
                    }
                } else if (campo.valor && campo.valor.trim() !== '') {
                    const valorHtml = formatearValorTexto(campo.valor);
                    const bloque = compacto
                        ? `<div style="margin-top: ${mt}; font-size: ${fsCampo}; line-height: 1.35; ${EVOL_TEXT_WRAP}"><strong style="font-size: ${fsNombre}">${campo.nombre}:</strong> <span style="${EVOL_TEXT_WRAP}">${valorHtml}</span></div>`
                        : `<div style="margin-top: ${mt}; ${EVOL_TEXT_WRAP}"><label><strong>${campo.nombre}:</strong></label><br /><span style="${EVOL_TEXT_WRAP}">${valorHtml}</span></div>`;
                    resultado += bloque;
                }
            });
        }

        return resultado;
    }

    // 🔧 FUNCIÓN HELPER - Verificar si un campo tiene contenido válido
    const tieneContenido = (valor) => {
        if (!valor) return false;
        if (typeof valor === 'string') {
            // Remover HTML tags para verificar contenido real
            const textoLimpio = valor.replace(/<[^>]*>/g, '').trim();
            return textoLimpio !== '';
        }
        return true;
    }

    // 🔧 FUNCIÓN HELPER - Verificar si hay contenido personalizado válido
    const tieneContenidoPersonalizado = (contenidoPersonalizado) => {
        if (!contenidoPersonalizado) return false;

        try {
            const contenido = JSON.parse(contenidoPersonalizado);
            if (!contenido || !Array.isArray(contenido)) return false;

            // Verificar si hay al menos un campo con contenido válido
            return contenido.some(campo => {
                if (campo.tipo === 'checkbox') {
                    return campo.check === true;
                } else {
                    return campo.valor && campo.valor.trim() !== '';
                }
            });
        } catch (e) {
            return false;
        }
    }

    const htmlSegmentoContenidoEvolucion = (evol) => {
        const wrapContenido = (inner) => `<div style="margin-bottom: 12px; ${EVOL_TEXT_WRAP}">${inner}</div>`;
        const wrapValor = (inner) => `<div style="${EVOL_TEXT_WRAP}">${inner}</div>`;
        let html = '';
        const personalizado = renderizarContenidoPersonalizado(evol.contenido_personalizado, { compacto: true });
        if (personalizado) {
            html += wrapContenido(personalizado);
        }
        if (evol.procedimiento && tieneContenido(evol.procedimiento)) {
            html += wrapContenido(`
                <div style="font-weight: 700; margin-bottom: 4px;">Procedimiento / evolución</div>
                ${wrapValor(evol.procedimiento)}
            `);
        }
        if (evol.eventos_adversos && tieneContenido(evol.eventos_adversos)) {
            html += wrapContenido(`
                <div style="font-weight: 700; margin-bottom: 4px;">Evento adverso</div>
                ${wrapValor(evol.eventos_adversos)}
            `);
        }
        if (evol.plan_manejo_evento_adverso && tieneContenido(evol.plan_manejo_evento_adverso)) {
            html += wrapContenido(`
                <div style="font-weight: 700; margin-bottom: 4px;">Plan de manejo</div>
                ${wrapValor(evol.plan_manejo_evento_adverso)}
            `);
        }
        if (!html) {
            html = '<p style="margin: 0; color: #6c757d;">Sin contenido registrado.</p>';
        }
        return html;
    };

    const construirHtmlResumenEvolucionIndividual = (evolucion) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
        const firmas = htmlFirmasEvolucionHistorico(evolucion);
        return wrapEvolucionDocumento(
            htmlTituloHistorialEvoluciones()
            + htmlMetadataSuperiorCompleta(
                nombreCompleto,
                documentoCompleto,
                nombreProfesionalEvol(evolucion),
                obtenerFechaHoraVisualizacion(evolucion),
                { margenBottom: '0' }
            )
            + htmlSeparadorEvolucion()
            + htmlSegmentoContenidoEvolucion(evolucion)
            + firmas
        );
    };

    const htmlFirmasEvolucionHistorico = (evolucion) => {
        const bloqueProf = htmlFirmaProfesionalDesdeEvol(evolucion);
        const bloquePac = evolucion.firma_paciente
            ? htmlFirmaPacienteSoloSiHayTrazo(evolucion.firma_paciente, piePacienteEvolucion())
            : '';
        if (bloqueProf) {
            return bloqueProf + bloquePac;
        }
        if (bloquePac) {
            return htmlSeparadorEvolucion() + bloquePac;
        }
        return '';
    };

    /** Secciones de contenido clínico para PDF (mismo orden que htmlSegmentoContenidoEvolucion). */
    const construirSeccionesContenidoEvolucionPdf = (evol) => {
        const secciones = [];
        const estilosTexto = { margenSuperiorMm: 0, htmlTextoCompacto: true, factorSaltoLineaPdf: 0.28, espacioPostBloqueTextoMm: 0.35 };
        const estilosBloque = { margenSuperiorMm: 2, htmlTextoCompacto: false };

        const personalizado = renderizarContenidoPersonalizado(evol.contenido_personalizado, { compacto: true });
        if (personalizado) {
            secciones.push({ tipo: 'texto', contenido: personalizado, estilos: estilosTexto });
        }
        if (evol.procedimiento && tieneContenido(evol.procedimiento)) {
            secciones.push({
                tipo: 'texto',
                titulo: 'Procedimiento / evolución',
                contenido: evol.procedimiento,
                estilos: estilosBloque
            });
        }
        if (evol.eventos_adversos && tieneContenido(evol.eventos_adversos)) {
            secciones.push({
                tipo: 'texto',
                titulo: 'Evento adverso',
                contenido: evol.eventos_adversos,
                estilos: estilosBloque
            });
        }
        if (evol.plan_manejo_evento_adverso && tieneContenido(evol.plan_manejo_evento_adverso)) {
            secciones.push({
                tipo: 'texto',
                titulo: 'Plan de manejo',
                contenido: evol.plan_manejo_evento_adverso,
                estilos: estilosBloque
            });
        }
        if (secciones.length === 0) {
            secciones.push({
                tipo: 'texto',
                contenido: 'Sin contenido registrado.',
                estilos: { margenSuperiorMm: 0, htmlTextoCompacto: true }
            });
        }
        return secciones;
    };

    const construirSeccionesFirmasEvolucionPdf = (evol, esIndep) => {
        const secciones = [];
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
        const estilosFirma = { estiloEvolucion: true, separadorPrevia: true };
        let huboFirmaProf = false;

        if (!esIndep) {
            const tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
                evol.profesional_tratante_completo !== 'null' &&
                evol.profesional_tratante_completo !== 'No registrado');
            const imgFirmaProf = firmaProfesionalImagenEvolucion(evol);
            if (tieneProfesionalRegistrado && imgFirmaProf) {
                secciones.push({
                    tipo: 'firma',
                    imagenBase64: imgFirmaProf,
                    metadata: metadataFirmaProfesionalEvol(evol),
                    estilos: estilosFirma
                });
                huboFirmaProf = true;
            }
        }

        if (evol.firma_paciente) {
            secciones.push({
                tipo: 'firma',
                imagenBase64: evol.firma_paciente,
                metadata: {
                    tipo: 'paciente',
                    nombrePaciente: nombreCompleto,
                    documentoPaciente: documentoCompleto
                },
                estilos: {
                    estiloEvolucion: true,
                    separadorPrevia: !huboFirmaProf,
                    margenSuperiorMm: huboFirmaProf ? 2 : 0
                }
            });
        }
        return secciones;
    };

    const construirEncabezadoPdfEvolucion = () => (
        encabezadoPersonalizado ? {
            izquierda: encabezadoPersonalizado.izquierda || '',
            centro: encabezadoPersonalizado.centro || '',
            derecha: encabezadoPersonalizado.derecha || ''
        } : null
    );

    const construirConfigPdfEvolucionIndividual = (evolucion) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
        const config = {
            filename: 'evolucion-' + (props.docPaciente || 'paciente') + '.pdf',
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: construirEncabezadoPdfEvolucion(),
            omitTablaPacienteInicial: true,
            secciones: [],
            firmas: []
        };

        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'HISTORIAL DE EVOLUCIONES',
            estilos: { fontSize: 11, espacioDespuesMm: 4, margenSuperiorMm: 2 }
        });
        config.secciones.push({
            tipo: 'metadata-superior-evolucion',
            paciente: nombreCompleto,
            documento: documentoCompleto,
            profesional: nombreProfesionalEvol(evolucion),
            fechaHora: obtenerFechaHoraVisualizacion(evolucion),
            estilos: { fontSize: 10, espacioDespuesMm: 1 }
        });
        config.secciones.push({
            tipo: 'rule',
            estilos: { margenSuperiorMm: 2, espacioDespuesMm: 4 }
        });
        config.secciones.push(...construirSeccionesContenidoEvolucionPdf(evolucion));
        config.secciones.push(...construirSeccionesFirmasEvolucionPdf(evolucion, esUsuarioProfesionalIndependiente()));

        if (esUsuarioProfesionalIndependiente() && firmaimg) {
            const metaIndep = {
                tipo: 'profesional',
                nombre: nombreProfesional || '',
                registroMedico: registroMedico || 'N/A',
                codigoHabilitacion: codigoHabilitacion || 'N/A'
            };
            const pieIndep = (textoPieFirma && String(textoPieFirma).trim()) || '';
            if (pieIndep) metaIndep.textoPieFirma = pieIndep;
            config.secciones.push({
                tipo: 'firma',
                imagenBase64: firmaimg,
                metadata: metaIndep,
                estilos: { estiloEvolucion: true, separadorPrevia: true }
            });
        }

        return config;
    };

    const construirConfigPdfEvolucionConsolidado = () => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
        const esIndep = esUsuarioProfesionalIndependiente();
        const config = {
            filename: 'evoluciones-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: construirEncabezadoPdfEvolucion(),
            omitTablaPacienteInicial: true,
            secciones: [],
            firmas: []
        };

        if (historialEvoluciones.length === 0) {
            config.secciones.push({
                tipo: 'subtitulo',
                contenido: 'HISTORIAL DE EVOLUCIONES',
                estilos: { fontSize: 11, espacioDespuesMm: 4, margenSuperiorMm: 2 }
            });
            config.secciones.push({
                tipo: 'texto',
                contenido: 'Sin evoluciones registradas.',
                estilos: { margenSuperiorMm: 0 }
            });
            return config;
        }

        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'HISTORIAL DE EVOLUCIONES',
            estilos: { fontSize: 11, espacioDespuesMm: 4, margenSuperiorMm: 2 }
        });

        historialEvoluciones.forEach((evol, index) => {
            if (index > 0) {
                config.secciones.push({
                    tipo: 'rule',
                    estilos: { margenSuperiorMm: 6, espacioDespuesMm: 4 }
                });
            }
            config.secciones.push({
                tipo: 'metadata-superior-evolucion',
                paciente: nombreCompleto,
                documento: documentoCompleto,
                profesional: nombreProfesionalEvol(evol),
                fechaHora: obtenerFechaHoraVisualizacion(evol),
                estilos: { fontSize: 10, margenSuperiorMm: index > 0 ? 2 : 0, espacioDespuesMm: 1 }
            });
            config.secciones.push({
                tipo: 'rule',
                estilos: { margenSuperiorMm: 2, espacioDespuesMm: 4 }
            });
            config.secciones.push(...construirSeccionesContenidoEvolucionPdf(evol));
            config.secciones.push(...construirSeccionesFirmasEvolucionPdf(evol, esIndep));
        });

        if (esIndep && firmaimg) {
            const metaIndep = {
                tipo: 'profesional',
                nombre: nombreProfesional || '',
                registroMedico: registroMedico || 'N/A',
                codigoHabilitacion: codigoHabilitacion || 'N/A'
            };
            const pieIndep = (textoPieFirma && String(textoPieFirma).trim()) || '';
            if (pieIndep) metaIndep.textoPieFirma = pieIndep;
            config.secciones.push({
                tipo: 'firma',
                imagenBase64: firmaimg,
                metadata: metaIndep,
                estilos: { estiloEvolucion: true, separadorPrevia: true }
            });
        }

        return config;
    };

    const abrirPdfParaImpresion = (pdf) => {
        const blob = pdf.output('blob');
        const url = URL.createObjectURL(blob);
        const printWindow = window.open(url, '_blank');

        if (printWindow) {
            printWindow.onload = function () {
                setTimeout(() => printWindow.print(), 500);
            };
        } else {
            const iframe = document.createElement('iframe');
            iframe.style.position = 'fixed';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.src = url;
            document.body.appendChild(iframe);
            iframe.onload = function () {
                setTimeout(() => {
                    try {
                        iframe.contentWindow.print();
                    } catch (e) {
                        alert('No se pudo abrir el diálogo de impresión. Por favor, descarga el PDF.');
                    }
                }, 500);
            };
        }
    };

    /** Vista del registro histórico en el formulario (mismo estilo que vista previa). */
    const construirHtmlVistaHistoricoFormulario = (evolucion) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
        const tituloContenido = `
            <div style="font-weight: 700; color: ${EVOL_DOC_TITLE_COLOR}; letter-spacing: 0.04em; margin-bottom: 12px; text-transform: uppercase;">
                Contenido de la evolución
            </div>`;
        return htmlMetadataSuperiorCompleta(
            nombreCompleto,
            documentoCompleto,
            nombreProfesionalEvol(evolucion),
            obtenerFechaHoraVisualizacion(evolucion),
            { margenBottom: '0' }
        )
            + htmlSeparadorEvolucion()
            + tituloContenido
            + htmlSegmentoContenidoEvolucion(evolucion)
            + htmlFirmasEvolucionHistorico(evolucion);
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            paciente_id: pacienteId,
            profesional: nombreProfesional,
            firma: null,
            procedimiento: procedimiento,
            proxima_cita: proximaCita,
            eventos_adversos: eventosAdversos,
            plan_manejo_evento_adverso: planManejoEventoAdverso,
            hora_inicial: fechaHora || horaInicial,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido_personalizado: contenidoPersonalizado,
            firma_paciente: ''
        }

        if (canvasRef.current && !canvasRef.current.isEmpty()) {
            config.firma_paciente = canvasRef.current.toDataURL('image/png');
        }

        ///////////////////

        var contenidoPersonalizado = [];

        parametrosEvolucion.forEach((parametro) => {
            let campoPersonalizado = document.querySelector('#parametro_' + parametro.id);
            if (campoPersonalizado) {
                let nombreParametro = campoPersonalizado.dataset.nombre;
                let tipoParametro = campoPersonalizado.dataset.tipo;
                let valorParametro = campoPersonalizado.value;
                let checkParametro = campoPersonalizado.checked;

                let datoPersonalizado = { nombre: nombreParametro, tipo: tipoParametro, valor: valorParametro, check: checkParametro };

                contenidoPersonalizado.push(datoPersonalizado);
            }
        });

        config.contenido_personalizado = JSON.stringify(contenidoPersonalizado);

        ///////////////////

        console.log('Enviando datos de evolución:', config);

        axios.post('/evolucion', config)
            .then(response => {
                console.log('Evolución guardada exitosamente:', response.data);
                setLoading(false);
                setHabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({}); // Limpiar errores en caso de éxito

                // 🆕 Mostrar modal de confirmación RIPS después de guardar
                setShowModalRips(true);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error al guardar evolución:', error);
                console.log('Respuesta del servidor:', error.response?.data);

                // Manejo robusto de errores
                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        console.log('Errores de validación:', error.response.data.errors);
                        setErrorlist(error.response.data.errors);
                    } else if (error.response.data && error.response.data.message) {
                        console.log('Mensaje de error:', error.response.data.message);
                        setErrorlist({ general: error.response.data.message });
                    } else {
                        setErrorlist({ general: `Error ${error.response.status}: ${error.response.statusText}` });
                    }
                } else if (error.request) {
                    setErrorlist({ general: 'Error de conexión. Verifique su conexión a internet.' });
                } else {
                    setErrorlist({ general: 'Error inesperado al guardar la evolución.' });
                }
            })
    }



    const verEvolucion = (evolucion) => {
        // 🆕 CAMBIO: Cargar datos en formulario en lugar de abrir modal
        setEvolucionSeleccionada(evolucion);
        setModoVisualizacion(true);
        
        setTituloResumen('Evolución · Vista previa');
        setContenidoVistaPreviaRegistro(construirHtmlVistaHistoricoFormulario(evolucion));
        setResumenEvolucionIndividual(construirHtmlResumenEvolucionIndividual(evolucion));
    }

    const normalizarValorFechaParse = (valor) => {
        if (valor == null || valor === '') return null;
        if (valor instanceof Date) return valor;
        const s = String(valor).trim();
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s)) {
            return new Date(s.replace(' ', 'T'));
        }
        return new Date(s);
    };

    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : normalizarValorFechaParse(fecha);
        if (!d || Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    /** true si el valor es solo hora (p. ej. TIME de MySQL "16:36:32"), sin parte de fecha */
    const esCadenaSoloHora = (v) => {
        if (v == null || v === '') return false;
        const t = String(v).trim();
        return /^\d{1,2}:\d{2}(:\d{2})?$/.test(t);
    };

    /** Parte yyyy-mm-dd de un datetime ISO o "yyyy-mm-dd hh:mm:ss" */
    const parteSoloFechaDeCampo = (fe) => {
        if (fe == null || fe === '') return '';
        const s = String(fe).trim();
        if (s.includes('T')) return s.split('T')[0];
        return s.split(/\s+/)[0] || '';
    };

    const obtenerFechaHoraVisualizacion = (evolucion) => {
        if (!evolucion) return 'No registrada';
        const hi = evolucion.hora_inicial;
        const fe = evolucion.fecha;
        let valor = '';
        // Legado / migración: fecha en un campo (día) y hora en otro solo como TIME → combinar
        if (hi != null && hi !== '' && esCadenaSoloHora(hi) && fe != null && fe !== '') {
            const dia = parteSoloFechaDeCampo(fe);
            if (dia) {
                valor = `${dia} ${String(hi).trim()}`;
            }
        }
        if (!valor) {
            valor = hi || fe || '';
        }
        if (!valor) return 'No registrada';
        const normalizado = formatearFechaHoraParaInput(valor);
        if (!normalizado) return String(valor);
        return normalizado.replace('T', ' ');
    };

    const abrirModalPlantillas = () => {
        const primeraPlantilla = Array.isArray(listaPlantillas) && listaPlantillas.length > 0 ? listaPlantillas[0] : null;
        setPlantillaSeleccionadaId(primeraPlantilla ? String(primeraPlantilla.id) : '');
        setContenidoPlantillaSeleccionada(primeraPlantilla?.contenido || '');
        setContenidoPlantillaCopiado(false);
        setShowtratamientos(true);
    };

    const handleSeleccionPlantilla = (e) => {
        const idSeleccionado = e.target.value;
        setPlantillaSeleccionadaId(idSeleccionado);
        const plantilla = listaPlantillas.find((item) => String(item.id) === String(idSeleccionado));
        setContenidoPlantillaSeleccionada(plantilla?.contenido || '');
        setContenidoPlantillaCopiado(false);
    };

    const limpiarHtmlParaPegado = (html) => {
        const contenido = String(html || '').trim();
        if (!contenido) return '';
        const htmlConSaltos = contenido
            .replace(/<\s*br\s*\/?>/gi, '\n')
            .replace(/<\/\s*p\s*>/gi, '\n')
            .replace(/<\/\s*div\s*>/gi, '\n')
            .replace(/<\/\s*li\s*>/gi, '\n')
            .replace(/<\s*li[^>]*>/gi, '- ');
        const contenedor = document.createElement('div');
        contenedor.innerHTML = htmlConSaltos;
        return (contenedor.textContent || contenedor.innerText || '')
            .replace(/\u00a0/g, ' ')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    };

    const copiarContenidoPlantilla = async () => {
        const texto = limpiarHtmlParaPegado(contenidoPlantillaSeleccionada);
        if (!texto) return;
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(texto);
            } else {
                const areaTemporal = document.createElement('textarea');
                areaTemporal.value = texto;
                areaTemporal.setAttribute('readonly', '');
                areaTemporal.style.position = 'absolute';
                areaTemporal.style.left = '-9999px';
                document.body.appendChild(areaTemporal);
                areaTemporal.select();
                document.execCommand('copy');
                document.body.removeChild(areaTemporal);
            }
            setContenidoPlantillaCopiado(true);
        } catch (error) {
            console.log('No se pudo copiar el contenido de la plantilla:', error);
            setContenidoPlantillaCopiado(false);
        }
    };

    const establecerFechaHoraActual = () => {
        const fechaFormateada = formatearFechaHoraParaInput(new Date());
        setFechaHora(fechaFormateada);
        setHoraInicial(fechaFormateada);
    }

    const nuevaEvolucion = () => {
        setEvolucionSeleccionada(null);
        setModoVisualizacion(false);
        setContenidoVistaPreviaRegistro('');
        setHabilitarBotonGuardar(false);
        setFechaHora('');
        setErrorlist({}); // Limpiar errores
        // Limpiar formulario
        setProcedimiento('');
        setProximaCita('');
        setEventosAdversos('');
        setPlanManejoEventoAdverso('');
        // Resetear acordeones - Todos abiertos para aprovechar espacio
        setAcordeonProcedimiento(true);
        setAcordeonPersonalizado(true);
        setAcordeonProximaCita(true);
        setAcordeonEventos(true);
        setAcordeonPlanManejo(true);
        setAcordeonFirmaPaciente(true);
        (parametrosEvolucion || []).forEach((parametro) => {
            const elemento = document.querySelector('#parametro_' + parametro.id);
            if (elemento) {
                if (parametro.tipo_campo === 'checkbox') {
                    elemento.checked = false;
                } else {
                    elemento.value = '';
                }
            }
        });
        if (canvasRef.current) {
            canvasRef.current.clear();
        }
    }

    const cargarDatosEnFormulario = (evolucion) => {
        if (parametrosEvolucion.length > 0) {
            setTimeout(() => {
                setProcedimiento(evolucion.procedimiento || '');
                setProximaCita(evolucion.proxima_cita || '');
                setEventosAdversos(evolucion.eventos_adversos || '');
                setPlanManejoEventoAdverso(evolucion.plan_manejo_evento_adverso || '');

                if (evolucion.contenido_personalizado) {
                    const contenido = JSON.parse(evolucion.contenido_personalizado);
                    contenido.forEach((campo) => {
                        parametrosEvolucion.forEach((parametro) => {
                            if (parametro.nombre === campo.nombre) {
                                const elemento = document.querySelector('#parametro_' + parametro.id);
                                if (elemento) {
                                    if (campo.tipo === 'checkbox') {
                                        elemento.checked = campo.check;
                                    } else {
                                        elemento.value = campo.valor;
                                    }
                                }
                            }
                        });
                    });
                }
                if (evolucion.firma_paciente && canvasRef.current) {
                    canvasRef.current.fromDataURL(evolucion.firma_paciente);
                }
            }, 200);
        }
    }

    const imprimirEvolucion = async () => {
        if (!evolucionSeleccionada) {
            alert('No hay evolución seleccionada para imprimir');
            return;
        }

        try {
            const config = construirConfigPdfEvolucionIndividual(evolucionSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            abrirPdfParaImpresion(pdf);
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }

    const descargarPdfEvolucion = async () => {
        if (!evolucionSeleccionada) return;

        try {
            const config = construirConfigPdfEvolucionIndividual(evolucionSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename);
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }

    // ❌ FUNCIÓN OBSOLETA - Comentada porque usa campos eliminados (procedimiento, proxima_cita)
    // Se usa verEvolucion() en su lugar
    /*
    const verResumenEvolucion = (ttlResumen, evolucionIndividual) => {
        setTituloResumen(ttlResumen);

        const segmentoFirmaPaciente = evolucionIndividual.firma_paciente ? "<br /><label>Firma del paciente</label><br /><img src='" + evolucionIndividual.firma_paciente + "' width='160' />" : "";
        let segmentoContenidoPersonalizado = renderizarContenidoPersonalizado(evolucionIndividual.contenido_personalizado);

        const contenidoEvolucion = "<label>Fecha:</label><br />" +
            evolucionIndividual.fecha +
            "<br /><label>Procedimiento:</label><br />" +
            evolucionIndividual.procedimiento +
            segmentoContenidoPersonalizado +
            "<label>Próxima cita:</label>" +
            evolucionIndividual.proxima_cita +
            "<label>Evento adverso:</label><br />" +
            evolucionIndividual.eventos_adversos +
            "<br /><br /><label>Plan de manejo evento adverso:</label><br />" +
            evolucionIndividual.plan_manejo_evento_adverso +
            segmentoFirmaPaciente;
        setResumenEvolucionIndividual(contenidoEvolucion);
        setProfesionalEvolucionIndividual(evolucionIndividual.profesional);
        setRegistroMedicoEvolucionIndividual(evolucionIndividual.registro_medico);
        setCodigoHabilitacionEvolucionIndividual(evolucionIndividual.codigo_habilitacion);
        setFirmaEvolucionIndividual(evolucionIndividual.firma);

        setShowModalResumen(true);
    }
    */


    const handleEventoAdverso = (evento) => {
        setEventosAdversos(evento.target.options[evento.target.selectedIndex].text);
        setPlanManejoEventoAdverso(evento.target.value);
        setAcordeonPlanManejo(true);
    }


    const imprimirConsolidado = async () => {
        try {
            const config = construirConfigPdfEvolucionConsolidado();
            const pdf = await generarPdfConTextoNativo(config);
            abrirPdfParaImpresion(pdf);
        } catch (error) {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }

    const descargarPdf = async () => {
        try {
            const config = construirConfigPdfEvolucionConsolidado();
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename);
        } catch (error) {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }


    const agregarPlantillaTratamiento = async () => {
        await copiarContenidoPlantilla();
    }


    const renderCampoPersonalizado = (campo) => {
        if (modoVisualizacion && evolucionSeleccionada) {
            const contenido = JSON.parse(evolucionSeleccionada.contenido_personalizado || '[]');
            const valor = contenido.find(c => c.nombre === campo.nombre);

            // 🔧 OCULTAR CAMPOS VACÍOS - Solo mostrar si tiene valor
            if (!valor) {
                return null; // No renderizar si no hay valor
            }

            if (campo.tipo_campo === 'checkbox') {
                // Para checkboxes, solo mostrar si está marcado
                if (!valor.check) {
                    return null;
                }
                return (
                    <div className="form-group" key={campo.id}>
                        <label><strong>{campo.nombre}</strong></label>
                        <div className="form-control-plaintext">Sí</div>
                    </div>
                );
            } else {
                // Para otros campos, solo mostrar si tiene valor y no está vacío
                if (!valor.valor || valor.valor.trim() === '') {
                    return null;
                }
                return (
                    <div className="form-group" key={campo.id}>
                        <label><strong>{campo.nombre}</strong></label>
                        <div className="form-control-plaintext">{valor.valor}</div>
                    </div>
                );
            }
        }

        if (campo.tipo_campo == 'checkbox') {
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <input type="checkbox" className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} style={{ width: '30px' }} />
            </div>
        }
        else if (campo.tipo_campo == 'text') {
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <input type="text" className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} />
            </div>
        }
        else if (campo.tipo_campo == 'textarea') {
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <textarea className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} rows="5"></textarea>
            </div>
        }
        else {
            // Fallback para cualquier otro tipo
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <input type="text" className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} />
            </div>
        }
    }


    const handleCerrarTratamientos = () => {
        setShowtratamientos(false);
        setContenidoPlantillaCopiado(false);
    };

    const getInfoAnamnesisPDF = () => '';

    const abrirHistoriaClinicaJson = () => {
        history.push(`/historia-clinica-json?id=${paciente_id}`);
    };

    const abrirExamenes = () => { setShowExamenes(true); setCargarHistorialExamenes(true); };
    const cerrarExamenes = () => { setShowExamenes(false); setCargarHistorialExamenes(false); };
    const abrirFormulas = () => { setShowFormulas(true); setCargarHistorialFormulas(true); };
    const cerrarFormulas = () => { setShowFormulas(false); setCargarHistorialFormulas(false); };
    const abrirIncapacidades = () => { setShowIncapacidades(true); setCargarHistorialIncapacidades(true); };
    const cerrarIncapacidades = () => { setShowIncapacidades(false); setCargarHistorialIncapacidades(false); };
    const abrirRecomendaciones = () => { setShowRecomendaciones(true); setCargarHistorialRecomendaciones(true); };
    const cerrarRecomendaciones = () => { setShowRecomendaciones(false); setCargarHistorialRecomendaciones(false); };
    const abrirRemisiones = () => { setShowRemisiones(true); setCargarHistorialRemisiones(true); };
    const cerrarRemisiones = () => { setShowRemisiones(false); setCargarHistorialRemisiones(false); };
    const abrirContraremisiones = () => { setShowContraremisiones(true); setCargarHistorialContraremisiones(true); };
    const cerrarContraremisiones = () => { setShowContraremisiones(false); setCargarHistorialContraremisiones(false); };
    const abrirConsentimientos = () => { setShowConsentimientos(true); setCargarHistorialConsentimientos(true); };
    const cerrarConsentimientos = () => { setShowConsentimientos(false); setCargarHistorialConsentimientos(false); };
    const abrirOdontograma = () => { setShowOdontograma(true); };
    const cerrarOdontograma = () => { setShowOdontograma(false); };

    const abrirArchivosClinicos = () => {
        setShowArchivosClinicos(true);
    };
    const cerrarArchivosClinicos = () => {
        setShowArchivosClinicos(false);
    };
    const abrirToxina = () => {
        history.push(`/toxina-botulinica?id=${paciente_id}`);
    };
    const abrirRipsConvenio = () => { setShowRipsConvenio(true); setCargarHistorialRipsConvenio(true); };
    const cerrarRipsConvenio = () => { setShowRipsConvenio(false); setCargarHistorialRipsConvenio(false); };

    const obtenerPacienteParaRips = () => {
        const p = paciente || {};
        return {
            id: p.id || paciente_id,
            primerNombre: p.primerNombre ?? p.primer_nombre ?? '',
            segundoNombre: p.segundoNombre ?? p.segundo_nombre ?? '',
            primerApellido: p.primerApellido ?? p.primer_apellido ?? '',
            segundoApellido: p.segundoApellido ?? p.segundo_apellido ?? '',
            numeroDocumento: p.numeroDocumento ?? p.numero_documento ?? '',
            tipoDocumento: p.tipoDocumento ?? p.tipo_documento ?? 'CC',
        };
    };

    const cerrarRipsFev = () => setShowRipsFev(false);
    const cerrarRipsSinFev = () => setShowRipsSinFev(false);

    const abrirModalRipsFev = () => {
        if (props.abrirRipsFev && typeof props.abrirRipsFev === 'function') {
            props.abrirRipsFev();
        } else {
            setShowRipsFev(true);
        }
    };

    const abrirModalRipsSinFev = () => {
        if (props.abrirRipsSinFev && typeof props.abrirRipsSinFev === 'function') {
            props.abrirRipsSinFev();
        } else {
            setShowRipsSinFev(true);
        }
    };

    // 🆕 Funciones para manejar el modal de RIPS
    const handleCerrarModalRips = () => {
        setShowModalRips(false);
        // Limpiar campos para permitir nueva evolución
        nuevaEvolucion();
        // Mostrar toast de confirmación solo si la función existe (cuando se usa como modal)
        if (props.guardarCambios && typeof props.guardarCambios === 'function') {
            props.guardarCambios('La evolución ha sido completada');
        }
    };

    const handleRegistrarRipsFev = () => {
        setShowModalRips(false);
        if (props.guardarCambios && typeof props.guardarCambios === 'function') {
            props.guardarCambios('La evolución ha sido completada');
        }
        if (props.abrirRipsFev && typeof props.abrirRipsFev === 'function') {
            if (props.cerrarModal && typeof props.cerrarModal === 'function') {
                props.cerrarModal();
            }
            props.abrirRipsFev();
        } else {
            setShowRipsFev(true);
        }
    };

    const handleRegistrarRipsSinFev = () => {
        setShowModalRips(false);
        if (props.guardarCambios && typeof props.guardarCambios === 'function') {
            props.guardarCambios('La evolución ha sido completada');
        }
        if (props.abrirRipsSinFev && typeof props.abrirRipsSinFev === 'function') {
            if (props.cerrarModal && typeof props.cerrarModal === 'function') {
                props.cerrarModal();
            }
            props.abrirRipsSinFev();
        } else {
            setShowRipsSinFev(true);
        }
    };

    // 🔒 Verificación de permisos
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (hasPermission === null) {
        return (
            <div className="hold-transition">
                <Loading />
            </div>
        );
    }

    // Render del componente
    if (loggedIn) {
        return (

            <>
                <Header />
                <Aside 
                    activelink="patients"
                    atencionPaciente={true}
                    abrirArchivosClinicos={abrirArchivosClinicos}
                    abrirEvolucion={() => history.push(`/evolucion-paciente?id=${paciente_id}`)}
                    abrirHistoriaClinicaJson={abrirHistoriaClinicaJson}
                    abrirExamenes={abrirExamenes}
                    abrirFormulas={abrirFormulas}
                    abrirIncapacidades={abrirIncapacidades}
                    abrirRecomendaciones={abrirRecomendaciones}
                    abrirRemisiones={abrirRemisiones}
                    abrirContraremisiones={abrirContraremisiones}
                    abrirConsentimientos={abrirConsentimientos}
                    abrirRipsFev={abrirModalRipsFev}
                    abrirRipsSinFev={abrirModalRipsSinFev}
                    abrirRipsConvenio={abrirRipsConvenio}
                    abrirOdontograma={abrirOdontograma}
                    abrirToxina={abrirToxina}
                    esFacturador={esFacturador}
                    tienePermisoDocumentos={tienePermisoDocumentos}
                    tienePermisoRips={tienePermisoRips}
                    tienePermisoOdontograma={tienePermisoOdontograma}
                    tienePermisoToxina={tienePermisoToxina}
                    tienePermisoEvolucion={tienePermisoEvolucionMenu}
                    tienePermisoHistoriaClinica={tienePermisoHistoriaClinica}
                />
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">

                        {/* 🆕 TAREA 4.1.2 y 4.1.3 - Mostrar loading o error al cargar paciente */}
                        {loadingPaciente && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info" role="alert">
                                        <i className="fas fa-spinner fa-spin"></i> Cargando datos del paciente...
                                    </div>
                                </div>
                            </div>
                        )}

                        {errorPaciente && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-danger" role="alert">
                                        <i className="fas fa-exclamation-triangle"></i> {errorPaciente}
                                        <br />
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary btn-sm mt-2"
                                            onClick={() => history.goBack()}
                                        >
                                            <i className="fas fa-arrow-left"></i> Volver
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {!loadingPaciente && !errorPaciente && (
                        <div className="row">
                            <div className="col-md-9" style={{ minWidth: 0, maxWidth: '100%', overflowX: 'hidden' }}>

                                {/* 🆕 TÍTULO Y BOTONES DE ACCIÓN SUPERIORES */}
                                <div className="card" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', borderLeft: '4px solid #343a40' }}>
                                    <div className="card-body" style={{ padding: '15px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                                                <h3 style={{ margin: 0, color: '#343a40' }}>
                                                    <i className="fas fa-notes-medical"></i> EVOLUCIÓN DEL PACIENTE
                                                </h3>
                                                {/* Fila 1: navegación rápida */}
                                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-dark"
                                                        onClick={() => history.push(`/atender-paciente?id=${paciente_id}`)}
                                                        title="Volver a Atención del Paciente"
                                                        style={{ padding: '4px 8px' }}
                                                    >
                                                        <i className="fas fa-user-injured"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-info"
                                                        onClick={() => history.push(`/estado-cuenta-paciente?id=${paciente_id}`)}
                                                        title="Ver Cartera del Paciente"
                                                        style={{ padding: '4px 8px' }}
                                                    >
                                                        <i className="fas fa-dollar-sign"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-primary"
                                                        onClick={() => (esFacturador ? abrirModalRipsFev() : abrirModalRipsSinFev())}
                                                        title="Registrar RIPS del paciente"
                                                        style={{ padding: '4px 8px' }}
                                                    >
                                                        <i className="fas fa-file-medical"></i>
                                                    </button>
                                                    {/* RDA oculto temporalmente — reactivar: cambiar false por true */}
                                                    {false && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm"
                                                        onClick={() => {
                                                            const params = new URLSearchParams();
                                                            params.set('pacienteId', paciente_id);
                                                            if (evolucionSeleccionada?.id) {
                                                                params.set('evolucionId', evolucionSeleccionada.id);
                                                            }
                                                            history.push(`/crear-rda-externa?${params.toString()}`);
                                                        }}
                                                        title="Generar RDA Consulta Externa"
                                                        style={{ padding: '4px 8px', backgroundColor: '#20c997', borderColor: '#20c997', color: '#fff' }}
                                                    >
                                                        <i className="fas fa-file-export"></i>
                                                    </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-secondary"
                                                        onClick={() => history.goBack()}
                                                        title="Volver"
                                                        style={{ padding: '4px 8px' }}
                                                    >
                                                        <i className="fas fa-arrow-left"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {/* Fila 2: acciones principales */}
                                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm"
                                                    onClick={(e) => { e.preventDefault(); nuevaEvolucion(); }}
                                                >
                                                    <i className="fas fa-plus"></i> Nueva Evolución
                                                </button>
                                                {!modoVisualizacion && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-info btn-sm"
                                                        onClick={(e) => { e.preventDefault(); abrirModalPlantillas(); }}
                                                        title="Plantillas"
                                                        aria-label="Plantillas"
                                                    >
                                                        <i className="fas fa-clone"></i>
                                                    </button>
                                                )}
                                                {evolucionSeleccionada && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-info btn-sm"
                                                        onClick={(e) => { e.preventDefault(); setShowModalResumen(true); }}
                                                    >
                                                        <i className="fas fa-eye"></i> Ver Resumen
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        
                                        {!modoVisualizacion && (
                                            <div style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #dee2e6' }}>
                                                {(() => {
                                                    const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
                                                    return (
                                                        <div style={{ display: 'flex', gap: '30px', fontSize: '14px', flexWrap: 'wrap' }}>
                                                            <div>
                                                                <strong><i className="fas fa-user"></i> Paciente:</strong> {nombreCompleto}
                                                            </div>
                                                            <div>
                                                                <strong><i className="fas fa-id-card"></i> Documento:</strong> {documentoCompleto}
                                                            </div>
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    {/* Mostrar errores generales */}
                                    {errorlist?.general && (
                                        <div className="alert alert-danger" role="alert">
                                            <i className="fas fa-exclamation-triangle"></i> {errorlist.general}
                                        </div>
                                    )}

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* Profesional tratante + fecha/hora en un único bloque */}
                                            {!modoVisualizacion && (
                                                <div className="col-md-12">
                                                    <div className="card" style={{ marginBottom: '15px' }}>
                                                        <div className="card-body" style={{ padding: '15px' }}>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group" style={{ marginBottom: '0' }}>
                                                                        <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            value={profesionalTratante}
                                                                            readOnly
                                                                            style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                                        />
                                                                        <small className="text-muted">Usuario que realiza la evolución</small>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-0">
                                                                        <label><i className="far fa-calendar-alt"></i> Fecha y Hora</label>
                                                                        <div className="input-group">
                                                                            <input
                                                                                type="datetime-local"
                                                                                className="form-control"
                                                                                value={fechaHora}
                                                                                onChange={(e) => {
                                                                                    setFechaHora(e.target.value);
                                                                                    setHoraInicial(e.target.value);
                                                                                }}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button type="button" className="btn btn-primary btn-sm" onClick={establecerFechaHoraActual}>
                                                                                    <i className="fas fa-clock"></i> Hoy
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* ❌ ACORDEÓN PROCEDIMIENTO - ELIMINADO POR SOLICITUD DEL USUARIO */}
                                            {/* {(!modoVisualizacion || tieneContenido(evolucionSeleccionada?.procedimiento)) && (
                                                <div className="col-md-12">
                                                    ... código comentado ...
                                                </div>
                                            )} */}

                                            {modoVisualizacion && evolucionSeleccionada && (
                                                <div className="col-md-12 mb-3">
                                                    <div
                                                        className="evolucion-doc evolucion-registro-historico"
                                                        style={{
                                                            fontSize: EVOL_DOC_FS,
                                                            padding: `0 ${EVOL_DOC_PAD}`,
                                                            maxWidth: '100%',
                                                            overflowX: 'hidden',
                                                            overflowWrap: 'anywhere',
                                                            wordBreak: 'break-word',
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: contenidoVistaPreviaRegistro }}
                                                    />
                                                </div>
                                            )}

                                            {!modoVisualizacion && parametrosEvolucion && parametrosEvolucion.length > 0 && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonPersonalizado(!acordeonPersonalizado)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Evolución
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="personalizado" className={acordeonPersonalizado ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                            {
                                                                parametrosEvolucion.map((parametro) =>
                                                                    renderCampoPersonalizado(parametro)
                                                                ).filter(campo => campo !== null)
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {!modoVisualizacion && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonEventos(!acordeonEventos)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Eventos Adversos
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="eventos" className={acordeonEventos ? '' : 'collapse'}>
                                                            <div className="form-group" style={{ padding: '20px' }}>
                                                                <select className="form-control" id="evento" name="evento" onChange={(e) => handleEventoAdverso(e)}>
                                                                    <option></option>
                                                                    {
                                                                        plantillasEventosAdversos.map((plantilla) =>
                                                                            <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errorlist?.eventos_adversos && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.eventos_adversos}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {!modoVisualizacion && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonPlanManejo(!acordeonPlanManejo)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Plan de Manejo del Evento Adverso
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="plan-manejo" className={acordeonPlanManejo ? '' : 'collapse'} ref={panelPlanManejo}>
                                                            <div className="form-group plan-manejo-ckeditor">
                                                                <CKEditor editor={ClassicEditor} onChange={planManejoEventoAdversoHandler} data={planManejoEventoAdverso} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errorlist?.plan_manejo_evento_adverso && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.plan_manejo_evento_adverso}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {!modoVisualizacion && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonFirmaPaciente(!acordeonFirmaPaciente)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Firma Del Paciente
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="firma-paciente" className={acordeonFirmaPaciente ? '' : 'collapse'}>
                                                            <div className="form-group" style={{ padding: '20px' }}>
                                                                <SignatureCanvas ref={canvasRef} penColor='#242424' canvasProps={{ width: 300, height: 130, className: 'sigCanvas', style: { border: '1px solid' } }} />
                                                                <br />
                                                                <button className="btn btn-primary btn-sm" onClick={(e) => { e.preventDefault(); canvasRef.current.clear(); }}><i className="fas fa-eraser"></i> Borrar</button>&nbsp;
                                                            </div>
                                                            {errorlist?.firma_paciente && (
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.firma_paciente}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {!modoVisualizacion && (
                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label htmlFor="nombreProfesional">Firma</label>
                                                            <br></br>
                                                            <img src={firmaimg} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}

                                    {!modoVisualizacion && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <button type="submit" className="btn btn-primary" disabled={habilitarBotonGuardar}>
                                                    Guardar&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                                </button>
                                                &nbsp;
                                                <button type="button" className="btn btn-secondary" onClick={() => history.goBack()}>
                                                    <i className="fas fa-arrow-left"></i> Volver
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                </form>


                            </div>
                            <div className="col-md-3" style={{ borderLeft: '2px solid #dee2e6', paddingLeft: '20px' }}>
                                <div className="timeline-evolucion">
                                    <div style={{ 
                                        textAlign: 'center', 
                                        marginBottom: '20px', 
                                        padding: '10px',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '5px',
                                        border: '1px solid #dee2e6'
                                    }}>
                                        <i className="fas fa-history" style={{ color: '#343a40', marginRight: '8px' }}></i>
                                        <b style={{ color: '#343a40', fontSize: '16px', letterSpacing: '0.04em' }}>HISTORIAL DE EVOLUCIONES</b>
                                    </div>

                                    {
                                        historialEvoluciones.map((evol) =>

                                            <div className={`timeline-item-container ${evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? 'timeline-item-selected' : ''}`} key={evol.id} onClick={() => verEvolucion(evol)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className={`timeline-punto ${evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? 'timeline-punto-selected' : ''}`} style={evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8', boxShadow: '0 0 0 3px rgba(23, 162, 184, 0.2)' } : {}}></div></div>
                                                <div className="timeline-meta" style={evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? { 
                                                    backgroundColor: '#d1ecf1', 
                                                    borderColor: '#17a2b8',
                                                    borderWidth: '2px',
                                                    fontWeight: 'bold'
                                                } : {}}>
                                                    <i className="far fa-calendar-alt" style={{ marginRight: '8px', color: '#6c757d' }}></i>
                                                    {obtenerFechaHoraVisualizacion(evol)}
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>
                                    <i className="fas fa-file-medical-alt"></i> Resumen Completo
                                </button>

                            </div>
                        </div>
                        )}
                        {/* 🆕 TAREA 4.1.2 - Cierre del div condicional de loading/error */}

                        </div>
                    </section>
                </div>
                <ModalArchivosClinicos
                    show={showArchivosClinicos}
                    onHide={cerrarArchivosClinicos}
                />

                <Footer showToast={false} delay={0} />

                <Modal show={showModalResumen} onHide={() => setShowModalResumen(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: resumenEvolucionIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={descargarPdfEvolucion}>
                            <i className="fas fa-file-pdf"></i> Descargar PDF
                        </Button>
                        <Button variant="primary" onClick={imprimirEvolucion}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="secondary" onClick={() => setShowModalResumen(false)}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Resumen de Atenciones</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Botones de acción arriba del contenido */}
                        <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                            <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={(e) => { e.preventDefault(); descargarPdf(); }}
                            >
                                <i className="fas fa-file-pdf"></i> Descargar PDF
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={(e) => { e.preventDefault(); imprimirConsolidado(); }}
                            >
                                <i className="fas fa-print"></i> Imprimir
                            </button>
                        </div>
                        <div className="evolucion-doc" style={{ maxWidth: '100%', overflowX: 'hidden' }} dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalConsolidado(false)}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showTratamientos} onHide={handleCerrarTratamientos} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Plantillas para evolución</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <div className="form-group">
                            <label>Seleccionar plantilla</label>
                            <select
                                className="form-control"
                                id="seleccionPlantilla"
                                value={plantillaSeleccionadaId}
                                onChange={handleSeleccionPlantilla}
                            >
                                <option value="">Seleccione una plantilla</option>
                                {listaPlantillas.map((plantilla) => (
                                    <option key={plantilla.id} value={plantilla.id}>{plantilla.titulo}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group mb-0">
                            <label>Contenido</label>
                            <div
                                className="form-control"
                                style={{ minHeight: '280px', maxHeight: '48vh', overflowY: 'auto', backgroundColor: '#f8f9fa' }}
                            >
                                {contenidoPlantillaSeleccionada ? (
                                    <div dangerouslySetInnerHTML={{ __html: contenidoPlantillaSeleccionada }} />
                                ) : (
                                    <span className="text-muted">Selecciona una plantilla para visualizar su contenido.</span>
                                )}
                            </div>
                            <small className="text-muted">
                                Copia este contenido y pégalo en el campo de evolución que necesites.
                            </small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant={contenidoPlantillaCopiado ? "success" : "primary"}
                            onClick={agregarPlantillaTratamiento}
                            disabled={!contenidoPlantillaSeleccionada}
                        >
                            <i className="far fa-copy"></i> {contenidoPlantillaCopiado ? 'Copiado' : 'Copiar contenido'}
                        </Button>
                        <Button variant="primary" onClick={handleCerrarTratamientos}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* 🆕 Modal de Confirmación RIPS */}
                <Modal show={showModalRips} onHide={handleCerrarModalRips} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <i className="fas fa-check-circle text-success"></i> Evolución Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                            La evolución del paciente fue guardada correctamente. ¿Deseas registrar los RIPS asociados a esta atención?
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {esFacturador ? (
                                // Usuario ES facturador (facturador = 0) → Mostrar botón RIPS FEV
                                <button
                                    className="btn btn-success btn-lg btn-block"
                                    onClick={handleRegistrarRipsFev}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
                                >
                                    <i className="fas fa-file-invoice"></i>
                                    <span>Sí, Registrar RIPS FEV</span>
                                </button>
                            ) : (
                                // Usuario NO es facturador (facturador = 1) → Mostrar botón RIPS Sin FEV
                                <button
                                    className="btn btn-primary btn-lg btn-block"
                                    onClick={handleRegistrarRipsSinFev}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
                                >
                                    <i className="fas fa-file-alt"></i>
                                    <span>Sí, Registrar RIPS Sin FEV</span>
                                </button>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCerrarModalRips}>
                            <i className="fas fa-times"></i> No, Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showRipsSinFev} onHide={cerrarRipsSinFev} size="xl" enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Registro RIPS Sin FEV</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RegistroRipsSinFev paciente={obtenerPacienteParaRips()} />
                    </Modal.Body>
                </Modal>

                <Modal show={showRipsFev} onHide={cerrarRipsFev} size="xl" enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Registro RIPS FEV</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RegistroRipsFev
                            paciente={obtenerPacienteParaRips()}
                            onClose={cerrarRipsFev}
                        />
                    </Modal.Body>
                </Modal>

                <Modal show={showRipsConvenio} onHide={cerrarRipsConvenio} size="xl" enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Registro RIPS Por Convenio</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RegistroRipsConvenio cargarHistorial={cargarHistorialRipsConvenio} cerrarModal={cerrarRipsConvenio} paciente={obtenerPacienteParaRips()} />
                    </Modal.Body>
                </Modal>

                <DocumentoPacienteModal show={showExamenes} onHide={cerrarExamenes} title="Ayudas Diagnósticas">
                    <ModalExamenes cargarHistorial={cargarHistorialExamenes} cerrarModal={cerrarExamenes} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <DocumentoPacienteModal show={showFormulas} onHide={cerrarFormulas} title="Fórmulas Médicas">
                    <ModalFormulas cargarHistorial={cargarHistorialFormulas} cerrarModal={cerrarFormulas} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <DocumentoPacienteModal show={showIncapacidades} onHide={cerrarIncapacidades} title="Incapacidades">
                    <ModalIncapacidades cargarHistorial={cargarHistorialIncapacidades} cerrarModal={cerrarIncapacidades} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <DocumentoPacienteModal show={showRecomendaciones} onHide={cerrarRecomendaciones} title="Recomendaciones">
                    <ModalRecomendaciones cargarHistorial={cargarHistorialRecomendaciones} cerrarModal={cerrarRecomendaciones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <DocumentoPacienteModal show={showRemisiones} onHide={cerrarRemisiones} title="Remisiones">
                    <ModalRemisiones cargarHistorial={cargarHistorialRemisiones} cerrarModal={cerrarRemisiones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <DocumentoPacienteModal show={showContraremisiones} onHide={cerrarContraremisiones} title="Contraremisiones">
                    <ModalContraremisiones cargarHistorial={cargarHistorialContraremisiones} cerrarModal={cerrarContraremisiones} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <DocumentoPacienteModal show={showConsentimientos} onHide={cerrarConsentimientos} title="Consentimientos">
                    <ModalConsentimientos cargarHistorial={cargarHistorialConsentimientos} cerrarModal={cerrarConsentimientos} anamnesis={getInfoAnamnesisPDF} docPaciente={paciente?.numeroDocumento || paciente?.numero_documento} paciente={paciente} />
                </DocumentoPacienteModal>

                <ModalOdontograma
                    show={showOdontograma}
                    onHide={cerrarOdontograma}
                    pacienteId={paciente_id}
                    paciente={{
                        primerNombre: paciente?.primerNombre ?? paciente?.primer_nombre ?? '',
                        segundoNombre: paciente?.segundoNombre ?? paciente?.segundo_nombre ?? '',
                        primerApellido: paciente?.primerApellido ?? paciente?.primer_apellido ?? '',
                        segundoApellido: paciente?.segundoApellido ?? paciente?.segundo_apellido ?? '',
                        tipoDocumento: paciente?.tipoDocumento ?? paciente?.tipo_documento ?? '',
                        numeroDocumento: paciente?.numeroDocumento ?? paciente?.numero_documento ?? '',
                    }}
                />

            </>
        );
    }

    return (
        <Loading />
    );
}
export default ModalEvolucion;